<template>
  <div class="tab-pane-inner vc-call-control-tab">
    <div class="vc-call-control-subtab-wrap" role="tablist" aria-label="通话控制分类">
      <button
        v-for="tab in subTabs"
        :key="tab.key"
        type="button"
        role="tab"
        class="vc-call-control-subtab-btn"
        :class="{ 'is-active': activeSubTab === tab.key }"
        :aria-selected="activeSubTab === tab.key ? 'true' : 'false'"
        @click="activeSubTab = tab.key"
      >
        {{ tab.label }}
      </button>
    </div>

    <div v-show="activeSubTab === SUB_TAB.BASIC" class="vc-call-control-panel" role="tabpanel">
      <CallControlSection :call-control="callControl" />
    </div>

    <div v-show="activeSubTab === SUB_TAB.SMART" class="vc-call-control-panel" role="tabpanel">
      <PresetOpeningSection
        :call-control="callControl"
        :customer-info-params="customerInfoParams"
      />
      <InterruptSettingsSection :call-control="callControl" />
      <MemoryEnabledSection :call-control="callControl" />
      <HumanMachineCollaborationSection :call-control="callControl" :disabled="g2Locked" />
      <LittleAssistantSection :assistant="littleAssistant" />
      <TransitionSoundSection :call-control="callControl" :preset-mode="presetMode" />
    </div>

    <div v-show="activeSubTab === SUB_TAB.ADVANCED" class="vc-call-control-panel" role="tabpanel">
      <InterfaceManagementSection
        :external-apis-json="externalApisJson"
        :external-apis-form="externalApisForm"
        :disabled="g2Locked"
      />
      <EventTriggerSection
        :event-triggers="eventTriggers"
        :external-apis-json="externalApisJson"
        :external-apis-form="externalApisForm"
        :intent-tag="intentTag"
        :disabled="g2Locked"
      />
      <CustomerInfoParamsSection :customer-info-params="customerInfoParams" />
    </div>
  </div>
</template>

<script>
import CallControlSection from '../voice-call/CallControlSection.vue'
import PresetOpeningSection from '../voice-call/PresetOpeningSection.vue'
import InterruptSettingsSection from '../voice-call/InterruptSettingsSection.vue'
import MemoryEnabledSection from '../voice-call/MemoryEnabledSection.vue'
import HumanMachineCollaborationSection from '../voice-call/HumanMachineCollaborationSection.vue'
import LittleAssistantSection from '../custom-tools/LittleAssistantSection.vue'
import TransitionSoundSection from '../voice-call/TransitionSoundSection.vue'
import EventTriggerSection from '../custom-tools/EventTriggerSection.vue'
import InterfaceManagementSection from '../custom-tools/InterfaceManagementSection.vue'
import CustomerInfoParamsSection from '../custom-tools/CustomerInfoParamsSection.vue'

const SUB_TAB = Object.freeze({
  BASIC: 'basic',
  SMART: 'smart',
  ADVANCED: 'advanced',
})

export default {
  name: 'LlmCallControlTab',
  components: {
    CallControlSection,
    PresetOpeningSection,
    InterruptSettingsSection,
    MemoryEnabledSection,
    HumanMachineCollaborationSection,
    LittleAssistantSection,
    TransitionSoundSection,
    EventTriggerSection,
    InterfaceManagementSection,
    CustomerInfoParamsSection,
  },
  props: {
    callControl: {
      type: Object,
      required: true,
    },
    presetMode: {
      type: String,
      default: '',
    },
    customerInfoParams: {
      type: Array,
      default: () => [],
    },
    littleAssistant: {
      type: Object,
      required: true,
    },
    externalApisJson: {
      type: Array,
      required: true,
    },
    externalApisForm: {
      type: Array,
      required: true,
    },
    eventTriggers: {
      type: Array,
      required: true,
    },
    intentTag: {
      type: Object,
      default: null,
    },
    g2Locked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      SUB_TAB,
      activeSubTab: SUB_TAB.BASIC,
      subTabs: [
        { key: SUB_TAB.BASIC, label: '基本设置' },
        { key: SUB_TAB.SMART, label: '智能设置' },
        { key: SUB_TAB.ADVANCED, label: '高级设置' },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.vc-call-control-tab {
  width: 100%;
  max-width: 100%;
}

.vc-call-control-subtab-wrap {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 37px;
  margin-bottom: 16px;
  padding: 0;
  overflow: hidden;
  box-sizing: border-box;
  background: #f5f7fa;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.vc-call-control-subtab-btn {
  border: none;
  background: transparent;
  color: #909399;
  font-size: 13px;
  line-height: 1.4;
  padding: 0 20px;
  cursor: pointer;
  flex: 0 0 auto;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  transition: background 0.2s ease, color 0.2s ease;

  &:hover:not(.is-active) {
    color: #1e293b;
  }

  &.is-active {
    background: #5668f0;
    color: #fff;
    font-weight: 400;
  }

  &:first-child.is-active {
    border-radius: 3px 0 0 3px;
  }

  &:last-child.is-active {
    border-radius: 0 3px 3px 0;
  }
}

.vc-call-control-panel {
  width: 100%;

  ::v-deep .vc-section {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
